export default __webpack_public_path__ + "static/media/s4_title-autumn.b7696c38.png";